import { IMAGE_PREFIX } from '../constances/server'

/**
 * 获取图片地址
 * @param {string} url
 */
export function getImgUrl(url) {
  if (!url) return ''
  if (typeof (url) === 'string' && url.startsWith('http')) return url
  return `${IMAGE_PREFIX}${url}`
}

/**
 * 获取canvas图片地址
 * @param {string} url
 */
export function getCanvasImgUrl(url) {
  if (!url) return ''
  if (typeof (url) === 'string' && url.startsWith('http')) return url
  return `${IMAGE_PREFIX}${url}`
}

/**
 * id构造器
 * @param {string} type text / image
 */
export function idCreator(type) {
  return `element_${type}_${new Date().getTime()}_${parseInt(Math.random() * 10000)}`
}

/**
 * 加载字体
 * @param {string} name 字体名
 * @param {string} url 字体地址
 */
export function loadFont(name, url) {
  console.log(name, url)
  const fontface = new FontFace(name, `url(https://resource.jinduo.com/Image/returnMultimedia?path=${url})`)
  document.fonts.add(fontface)
  fontface.load()
  return fontface.loaded
}

/**
 * base64 转 图片文件
 * @param {string} type dataurl / filename
 */
export function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}
